<template>
  <div class="ffootter" style="position: fixed; bottom: 0px; width:100%; background:rgba(44, 49, 52, 0.9); z-index:999;">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
        <p class="text-center" style="margin-bottom:5px; margin-top:5px; color:#fff;">
          <a href="http://buyhunter.ru/docs/8/political.docx" style="color:#fff" target="_blank">Политика конфеденциальности</a> | 
          <a href="http://buyhunter.ru/docs/8/soglash.docx" style="color:#fff" target="_blank">Пользовательское соглашение</a></p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 text-left" style="padding: 10px 0;">
          <img style="max-height: 30px;max-width: 100%;" :src="config.url + config.img_url + config.id + '/' + state.info.logo">
        </div>
        <div class="col-md-6 text-center">
          <div class="store" v-if="state.info.android">
            <a :href="state.info.android"><img :src="config.url + 'images/googlePlay.png'" height="42px" alt="Загрузите в AppStore"></a>
          </div>
          <div class="social" v-if="state.info.instagram">
            <a style="color:#fff;" target="_blank" :href="state.info.instagram">
              <i class="fab fa-instagram"></i>
            </a>
          </div>
          <div class="social" v-if="state.info.vk">
            <a style="color:#fff;" target="_blank" :href="state.info.vk">
              <i class="fab fa-vk"></i>
            </a>
          </div>
          <div class="social" v-if="state.info.flamp">
            <a style="color:#fff;" target="_blank" :href="state.info.flamp">
              FL
            </a>
          </div>
          <div class="store" v-if="state.info.ios">
            <a :href="state.info.ios"><img :src="config.url + 'images/appStore.png'" height="42px" alt="Загрузите в AppStore"></a>
          </div>
        </div>
        <div class="col-md-3 text-right" style="padding: 10px 0;">
          <p style="margin: 0" class="angrybirds"><a href="http://buyhunter.ru/" style="color:#fff;" target="_blank">Сделано в BuyHunter.ru</a></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    computed: {
      config() {
        return this.$store.state.config
      },
      state() {
        return this.$store.state
      },
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/footer.vue